import React from 'react';

import {HStack} from '@chakra-ui/react';
import Header from "@/components/entity/Header";
import {Button} from "@/components";
import {useLanguage} from "@/contexts/languageContext";

export const ModalHeader = ({title, close}) => {

    const { t } = useLanguage();

    return (
        <Header
            title={title}
            left={
                <HStack flex={1} align="center">
                    {
                        ![undefined, null, false].includes(close) &&
                        <Button
                            onClick={(_) => close?.()}
                            aria-label={t('actions.back')}
                            w="fit-content"
                            borderRadius="0"
                        >{t('actions.back')}</Button>
                    }
                </HStack>
            }
        />
    );
};

export default ModalHeader;
